import * as React from 'react';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CianLogo = function CianLogo(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? '48' : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: styles['cian-logo'],
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("rect", {
      width: size,
      height: size,
      fill: "#0468FF"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M30.6 14.1374C29.2325 14.1374 28.1241 12.9903 28.1241 11.5753C28.1241 10.16 29.2325 9.01302 30.6 9.01302C31.9675 9.01302 33.0762 10.16 33.0762 11.5753C33.0762 12.9903 31.9675 14.1374 30.6 14.1374ZM30.6 6C27.6176 6 25.2 8.5017 25.2 11.5882C25.2 12.6407 25.4818 13.6255 25.9712 14.4658C26.0711 14.6377 26.1797 14.8034 26.2964 14.9625L26.655 15.4771L30.6 20.4L34.9042 14.9618C35.5916 14.0242 36 12.8555 36 11.5882C36 8.5017 33.5825 6 30.6 6Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M32.622 32.1105V22.1978H28.3098V26.8536L24.0001 21.6L12 36.2286L15.9918 39.6L24.0001 29.8376L32.0082 39.6L36 36.2286L32.622 32.1105Z",
      fill: "white"
    })]
  });
};